import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import NetworkExtensionEmbed from './network-extension-embed';

@NgModule({
    declarations: [
        NetworkExtensionEmbed,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        TranslateModule,
        RouterModule
    ],
    providers: [

    ],
    exports: [
        NetworkExtensionEmbed
    ]
})

export class NetworkExtensionModule {
    constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/components/network-extension/network-extension.module.ts